import { Suspense, type ComponentProps } from 'react';
import { KeyboardHoldFallback } from '@/components/KeyboardHoldFallback';
import { lazyRoute } from '@/routing/lazyRoute';
import type { FeedbackCaptureSheet as Sheet } from './FeedbackCaptureSheet';

type FeedbackCaptureSheetProps = ComponentProps<typeof Sheet>;

const LazySheet = lazyRoute<typeof import('./FeedbackCaptureSheet'), FeedbackCaptureSheetProps>(
  () => import('./FeedbackCaptureSheet'),
  (module) => module.FeedbackCaptureSheet,
);

/**
 * T-0559: the feedback sheet, its own chunk. It is opened from a drawer row, a shake or a menu,
 * never at launch, and it carries the annotation editor and the upload, which every launch used to
 * parse. Drawn in a Suspense of its own, so nothing on the screen behind it waits.
 */
export function FeedbackCaptureSheet(props: FeedbackCaptureSheetProps) {
  return (
    <Suspense fallback={<KeyboardHoldFallback />}>
      <LazySheet {...props} />
    </Suspense>
  );
}
